<style>
@import './assets/colors.css';
@import './assets/main.css';
@import './assets/inputs.css';
@import './assets/easy-table-style.css';
</style>

<template>
    <SignaloBrowserVersionWarning />
    <SignaloAuthLoadingView v-if="authLoading" />
    <PageMaintenance v-if="helpersStore.maintenance" />
    <PageError
        v-else-if="error"
        :errorMessage="errorMessage"
        :tenantError="true"
    />
    <SignaloSignUpView
        v-else-if="
            !isLoggedIn &&
            $route.path === '/signup' &&
            !$route.path.includes('terminal-device')
        "
    />
    <SignaloRemindPasswordView
        v-else-if="
            !isLoggedIn &&
            $route.path === '/remind_password' &&
            !$route.path.includes('terminal-device')
        "
    />
    <SignaloSignUpConfirmEmail
        v-else-if="
            !isLoggedIn &&
            $route.path === '/signup_confirm_email' &&
            !$route.path.includes('terminal-device')
        "
    />
    <SignaloLoginView
        v-else-if="
            !isLoggedIn &&
            !$route.path.includes('terminal-device') &&
            !$route.path.includes('production-monitor')
        "
    />
    <v-app v-else>
        <SignaloLanguageChanger
            :followTerminalLanguage="authStore.isTerminal"
            class="hidden-language-changer"
            v-if="authStore?.tenant"
        />
        <SignaloNavDrawer
            v-model="drawer"
            :navType="navType"
            :navItems="navItems"
            :navActions="navActions"
            :displayActions="!authStore.isTerminal"
            v-if="
                !authStore.isTerminal ||
                authStore?.user?.terminal_mode === 'standard'
            "
            :redirectOnLogout="'dashboard'"
        />

        <PageNotPermitted v-if="$route.meta.permitted === false" />
        <RouterView v-else />
        <span
            style="text-align: right; padding: 0 8px"
            v-if="proccess?.env?.APP_VERSION"
            >{{ proccess?.env?.APP_VERSION }}</span
        >
    </v-app>
    <v-snackbar
        v-if="window?.appMounted"
        :timeout="helpersStore.snackbarTimeout"
        position="relative"
        location="bottom right"
        :color="helpersStore.snackbarColor"
        v-model="helpersStore.snackbarOn"
        @click="helpersStore.snackbarOn = false"
    >
        <div class="snackbar-message-container">
            <div class="error-icon-container">
                <v-icon v-if="helpersStore.error">mdi-alert-circle</v-icon>
            </div>
            <span>
                {{ helpersStore.snackbarText }}
            </span>
        </div>
        <template v-slot:actions>
            <v-btn
                class="report-problem-button"
                variant="elevated"
                v-if="helpersStore.error"
                @click="onErrorReport"
            >
                {{ $t('common.reportProblem') }}
            </v-btn>
            <v-btn
                class="handle-snackbar-action-button"
                variant="text"
                v-if="helpersStore.snackbarAction"
                @click="helpersStore.snackbarAction"
            >
                {{ $t('common.show') }}
            </v-btn>
        </template>
    </v-snackbar>
    <SignaloSingleAuthorizeDialog />
    <SignaloErrorReportDialog
        v-if="errorReportDialog"
        :open="errorReportDialog"
        @save="onErrorReportSave"
        @close="onErrorReportClose"
        :error="helpersStore.errorMessage"
        :loading="errorReportLoading"
    />
    <QRReaderComponent
        v-if="authStore.isLoggedIn && isQRScannerOpen"
        @close="() => (isQRScannerOpen = false)"
    />
    <SignaloBarcodeScanningInterceptor v-if="authStore.isLoggedIn" />
    <audio id="notification-player" class="notification-player">
        <source :src="require('./assets/notification.mp3')" type="audio/mpeg" />
    </audio>
    <SignaloSocketService v-if="isLoggedIn" />
    <ManageTableColumnsVisibilityDialog
        v-if="helpersStore.isManageTableColumnsVisibilityDialogOpen"
        :tableName="helpersStore.tableName"
        @close="helpersStore.closeManageTableColumnsvisibilityDialog"
    />
</template>

<script>
import { computed } from 'vue';
import { RouterView } from 'vue-router';

import * as AUTH_STORE from 'signalo-vue-auth-store';
import * as DATA_STORE from 'signalo-vue-data-store';
import * as HELPERS_STORE from 'signalo-vue-helpers-store';
import { CheckIsMobile } from 'signalo-vue-utils';
import { GetTerminalLoginData } from 'signalo-vue-utils';
import PageMaintenance from '@/components/global/PageMaintenance.vue';
import QRReaderComponent from '@/components/QRReader/QRReaderComponent.vue';

import NAVIGATION_ITEMS from './CONSTANTS/NAVIGATION_ITEMS';
import NAVIGATION_ACTIONS from './CONSTANTS/NAVIGATION_ACTIONS';
import * as SignaloSocketService from 'signalo-vue-socket-service';
const CHANNELS = SignaloSocketService.CHANNLES;
const EVENTS = SignaloSocketService.EVENTS;
import createVuetifyTheme from '@/utils/createVuetifyTheme';
import setColorVariablesFromPalette from '@/utils/setColorVariablesFromPalette';
import generateColorPalette from '@/utils/generateColorPalette';
import { getCurrentInstance } from 'vue';
import ManageTableColumnsVisibilityDialog from './components/ManageTableColumnsVisibilityDialog.vue';
import setCustomDimensionsCssVariables from './utils/setCustomDimensionsCssVariables';
import { Buffer } from 'buffer';
import i18nTenantTranslations from './i18nTenantTranslations';
export default {
    setup() {
        const authStore = AUTH_STORE.default();
        const dataStore = DATA_STORE.default();
        const helpersStore = HELPERS_STORE.default();

        window.hack = () => {
            helpersStore.hack();
        };
        return { authStore, dataStore, helpersStore };
    },
    components: {
        RouterView,
        PageMaintenance,
        QRReaderComponent,
        ManageTableColumnsVisibilityDialog,
    },
    data() {
        return {
            drawer:
                !this.helpersStore.isMobile ||
                /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
                    navigator.userAgent.toLowerCase()
                ),

            logoutInProgress: false,
            authLoading: true,
            navType: 'app',
            errorReportDialog: false,
            errorMessage: null,
            errorReportLoading: false,
            error: false,
            isQRScannerOpen: false,
            appInstance: null,
            window: window,
            dictionaryLoaded: false,
        };
    },
    watch: {
        'helpersStore.maintenance'(val) {
            if (val) {
                window.removeEventListener('beforeunload', this.preventReload);
            } else {
                if (
                    !window?.FFApi &&
                    !window.location.href.includes('localhost')
                ) {
                    window.addEventListener('beforeunload', this.preventReload);
                }
            }
        },
        $route: function (val) {
            const topLocation = this.dataStore.locations.find(
                (l) => l?.is_part_storage_root
            );
            val?.fullPath?.includes(`/storage/`) &&
            !val?.fullPath?.includes(`/storage/${topLocation?.id}`)
                ? (this.navType = 'warehouse')
                : (this.navType = 'app');
        },
        '$i18n.locale': function (val) {
            if (val !== localStorage.getItem('locale')) {
                localStorage.setItem('locale', val);
                if (this.authStore.isLoggedIn) {
                    this.dataStore.dictionary.reload();
                }
            }
        },
        isLoggedIn(val) {
            if (val) {
                if (val && !this.dictionaryLoaded) {
                    this.dataStore.dictionary.promise();
                    this.dictionaryLoaded = true;
                }
                this.$nextTick(() => {
                    this.listenSockets();
                });
            }
        },
        'authStore.user': {
            handler(val, prevVal) {
                if (val?.id === prevVal?.id) return;
                if (val?.id) {
                    this.$nextTick(() => {
                        this.authStore.watchNotifications();
                        this.listenSockets();
                    });
                }
            },
            deep: true,
        },
        'authStore.terminal': {
            handler(val, prevVal) {
                if (val?.id === prevVal?.id) return;
                if (val?.id) {
                    this.$nextTick(() => {
                        this.listenSockets();
                    });
                }
                if (val?.attributes?.hideSideMenu) {
                    this.authStore.unsubscribeNorifications();
                }
            },
            deep: true,
        },
    },
    provide() {
        return {
            navDrawer: computed(() => this.drawer),
        };
    },
    computed: {
        isLoggedIn() {
            return this.authStore.isLoggedIn;
        },
        navItems() {
            return NAVIGATION_ITEMS;
        },
        navActions() {
            return NAVIGATION_ACTIONS;
        },
    },
    async created() {
        this.appInstance = getCurrentInstance();
        await createVuetifyTheme(this.appInstance);
        this.$forceUpdate();
        this.loadDeviceId();
        this.watchInternetConnection();
        this.watchResize();
        this.emitter.on('toggle-sidebar', () => {
            this.drawer = !this.drawer;
        });
        this.handleAuth();
        this.helpersStore.watchInteractionStarted();
        this.emitter.on('open-scanner', () => {
            this.isQRScannerOpen = true;
        });
    },
    async mounted() {
        window.appMounted = false;
        //TO MAKE VUETIFY WORK ON OLDER BROWSERS
        window.helpersStore = this.helpersStore;
        this.helpersStore.checkHasWebcam();
        Element.prototype.animate = undefined;
        if (
            !this.helpersStore?.maintenance &&
            !window?.FFApi &&
            !window.location.href.includes('localhost')
        ) {
            window.addEventListener('beforeunload', this.preventReload);
        }
        this.listenCtrlS();
        if (this.isLoggedIn) {
            this.listenSockets();
        }
        window.appMounted = true;
        window.check = () => {
            console.log('TERMINAL:', this.authStore.terminal);
            console.log('USER:', this.authStore.user);
            console.log('ACCESS:', this.authStore?.user?.access);
        };
    },
    methods: {
        preventReload(e) {
            if (!this.helpersStore?.maintenance) {
                e.preventDefault();
                e.returnValue = '';
            }
        },
        watchInternetConnection() {
            window.addEventListener('online', () => {
                this.helpersStore.setIsOnline(true);
                this.errorMessage = null;
                this.error = null;
            });
            window.addEventListener('offline', () => {
                this.helpersStore.setIsOnline(false);
                this.error = true;
                this.errorMessage = this.$t('errors.noInternetConnection');
            });
        },
        logoutClick() {
            this.logoutInProgress = true;
            Promise.allSettled([this.authStore.logout()]).then(() => {
                this.logoutInProgress = false;
            });
        },
        onErrorReport($event) {
            $event?.stopPropagation();
            $event.preventDefault();
            this.errorReportDialog = true;
        },
        onErrorReportClose() {
            this.helpersStore.clearErrorMessage();
            this.errorReportDialog = false;
            this.helpersStore.snackbarOn = false;
        },
        async onErrorReportSave(errorDescription) {
            this.errorReportLoading = true;
            try {
                const body = {
                    description: errorDescription,
                    error: [
                        {
                            frontUrl: window.location.href,
                            error: this.helpersStore.errorMessage,
                        },
                    ],
                };
                await this.dataStore.errorLog.send(body);
                this.helpersStore.clearErrorMessage();
                this.errorReportDialog = false;
                this.helpersStore.snackbarSaved();
            } catch (err) {
                console.log(err);
            }
            this.errorReportLoading = false;
        },
        watchResize() {
            this.helpersStore.setIsMobile(this.checkIsMobile());
            window.addEventListener('resize', () => {
                this.helpersStore.setIsMobile(this.checkIsMobile());
            });
        },
        checkIsMobile() {
            return CheckIsMobile();
        },
        setTenantTranslations(tenant) {
            i18nTenantTranslations(tenant);
            this.$forceUpdate();
        },
        async handleAuth() {
            let ptab = [this.axios.get('/tenant')];

            let token = window.localStorage.getItem('authToken');
            const terminalToken = localStorage.getItem('terminalToken');
            let id, code;
            if (
                window.location.href.includes('context=') &&
                !window.location.href.includes('terminal-device')
            ) {
                const hex = window.location.href.split('context=')[1];
                const output = Buffer.from(hex, 'hex').toString();
                if (output.includes(':')) {
                    [id, code] = output.split(':');
                    id = Number(id);
                }
            }
            if (Number.isInteger(id) && code) {
                localStorage.clear();
                ptab.push(
                    this.axios
                        .post(
                            '/auth/login_by_code',
                            { user_id: id, password: code },
                            { permitAll: true }
                        )
                        .then((x) => {
                            if (x?.data?.status == 'ok') {
                                this.authStore.login(x.data);
                                // this.$router.push({
                                //     name: 'dashboard',
                                // });
                            }
                        })
                );
            } else if (terminalToken) {
                const secret = new TextEncoder().encode(terminalToken);
                let terminalLoginData;
                try {
                    terminalLoginData = await GetTerminalLoginData(
                        secret,
                        this.axios
                    );
                } catch (error) {
                    localStorage.removeItem('terminalToken');
                    this.authStore.forget();
                    this.authLoading = false;
                    return;
                }
                ptab.push(
                    new Promise((resolve) => {
                        resolve({
                            data: {
                                ...terminalLoginData,
                                status: 'ok',
                            },
                        });
                    }).then(async (res) => {
                        if (res?.data?.user?.attributes?.primaryColor) {
                            setColorVariablesFromPalette(
                                '--primary-',
                                generateColorPalette(
                                    res.data.user.attributes.primaryColor
                                )
                            );
                            await createVuetifyTheme(this.appInstance);

                            if (
                                typeof window?.FFApi?.setToolbarColor ===
                                    'function' &&
                                res?.data?.user?.attributes?.primaryColor
                            ) {
                                window.FFApi.setToolbarColor(
                                    res?.data?.user?.attributes?.primaryColor
                                );
                            }
                        }
                        if (window?.FFApi?.setToolbarTitle) {
                            window.FFApi.setToolbarTitle(
                                this.$getPropertyTranslation(
                                    res?.data?.user?.name
                                )
                            );
                        }
                        if (res?.data?.user?.attributes?.CUSTOM_DIMENSIONS) {
                            setCustomDimensionsCssVariables(
                                res?.data?.user?.attributes?.CUSTOM_DIMENSIONS
                            );
                        }

                        this.authStore.login(res.data);
                        if (res.data.user?.attributes?.default_view?.name) {
                            this.$router.push({
                                name: this.authStore.user.attributes
                                    .default_view.name,
                                force: true,
                                replace: true,
                            });
                        }
                        return this.dataStore.dictionary.promise();
                    })
                );
            } else if (token) {
                ptab.push(
                    this.axios.get('/auth').then((res) => {
                        this.authStore.login(res.data);
                        return this.dataStore.dictionary.promise();
                    })
                );
            }

            Promise.allSettled(ptab)
                .then((promises) => {
                    if (
                        promises[0].status === 'rejected' &&
                        promises[0].reason.code === 'ERR_NETWORK'
                    ) {
                        this.helpersStore.snackbar(
                            'Serwer nie odpowiada',
                            'warning'
                        );
                    }
                    if (promises[0].reason?.response?.status === 503) {
                        this.helpersStore.setMaintenance(true);
                        this.authLoading = false;
                        return;
                    }
                    let ok = true;
                    if (promises[0].status === 'fulfilled') {
                        let res = promises[0].value;
                        if (res.data.status == 'ok') {
                            this.setTenantTranslations(res.data.item);
                            this.authStore.setTenant(res.data.item);
                        }
                    } else {
                        ok = false;
                    }
                    if (!this.authStore.tenant) {
                        console.log('ERROR! TENANT NOT FOUND!');
                        this.errorMessage = this.$t('errors.tenantNotFound');
                        this.authLoading = false;
                        this.error = true;
                        return;
                    }
                    if (!ok) {
                        this.authStore.forget();
                    }

                    this.authLoading = false;
                })
                .catch(() => {
                    this.authStore.forget();
                    this.authLoading = false;
                });
        },
        listenSockets() {
            if (!this.$listenEvent) return;
            this.$listenEvent(CHANNELS.PUBLIC, EVENTS.NOTIFICATION, () => {
                this.helpersStore.debounce(() => {
                    this.authStore.watchNotifications();
                }, 200);
            });
            if (
                this.authStore.terminal ||
                this.authStore.user.authenticatable === 'Terminal'
            ) {
                const terminalId =
                    this.authStore?.terminal?.id || this.authStore?.user?.id;
                if (!terminalId) return;

                const terminalPrivateChannel = `private-${terminalId}.terminal`;

                this.$listenEvent(
                    terminalPrivateChannel,
                    EVENTS.NOTIFICATION,
                    () => {
                        //TODO na przyszłość globalny handler w appce
                    }
                );
            } else {
                const myId = this.authStore.user.id;
                if (!Number.isInteger(myId)) return;
                const myPrivateChannel = `private-${myId}.notification`;
                this.$listenEvent(myPrivateChannel, EVENTS.NOTIFICATION, () => {
                    this.helpersStore.debounce(() => {
                        this.authStore.watchNotifications();
                    }, 200);
                });

                this.$listenEvent(
                    myPrivateChannel,
                    EVENTS.DOCUMENT_READY,
                    (data) => {
                        this.helpersStore.snackbar(
                            data?.data?.title,
                            'success',
                            5000,
                            false,
                            () => {
                                window.open(
                                    data?.data?.description, //TAK description - backend jest upośledzony;
                                    '_blank'
                                );
                            }
                        );
                    }
                );

                const myPrivateUserChannel = `private-${myId}.user`;
                this.$listenEvent(
                    myPrivateUserChannel,
                    EVENTS.NOTIFICATION,
                    () => {
                        this.helpersStore.debounce(() => {
                            this.authStore.watchNotifications();
                        }, 200);
                    }
                );
            }
        },
        onCtrlS(e) {
            //workaround listener zapięty tutaj, bo w SignaloDialog ten event leciał wiele razy;
            if (e.ctrlKey && (e?.key === 's' || e?.code === 'KeyS')) {
                const actionsWrapper = document.getElementsByClassName(
                    'app-dialog-actions-container'
                )?.[0];
                if (actionsWrapper) {
                    const elevatedButtons =
                        actionsWrapper.getElementsByClassName(
                            'v-btn--elevated'
                        );
                    if (elevatedButtons?.length) {
                        elevatedButtons[elevatedButtons?.length - 1]?.click();
                    }
                }
            }
        },
        listenCtrlS() {
            document.addEventListener('keyup', this.onCtrlS);
        },
        loadDeviceId() {
            localStorage.removeItem('device_id');
            if (typeof window?.FFApi?.deviceId === 'function') {
                const deviceId = window?.FFApi?.deviceId();
                if (deviceId) {
                    localStorage.setItem('device_id', deviceId);
                }
            }
        },
    },
    errorCaptured(err) {
        //WORKAROUND - error in vue-router;
        // if (this.helpersStore.interceptorSnackbarDisabled) return;
        if (err.toString().includes('Missing required param')) return;
        if (err.toString().includes('getBoundingClientRect')) return;
        if (err.toString().includes('SAD_CLOSE')) return;
        if (err?.status === 401 || err?.response?.status === 401) return;
        console.error(err);
        const error = {
            error: err.toString(),
            route: window.location.href,
        };
        this.$nextTick(() => {
            this.helpersStore.snackbarError(error);
        });
        return false;
    },
};
</script>

<style>
.preview-header {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    padding: 4px 8px;
}
.preview-header {
    background-color: var(--greyscale-5-white) !important;
    padding: 4px 16px;
}
.preview-header .preview-header-icon {
    margin-right: 4px;
}
.menu-action {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.menu-action .operation-icon {
    margin-right: 8px;
}

.manage-modal-header {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    padding: 4px 8px;
}
.manage-modal-header .v-icon {
    margin-right: 4px;
}

.snackbar-message-container {
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
}
.snackbar-message-container .error-icon-container {
    margin-right: 4px;
}

.v-btn.report-problem-button {
    background-color: var(--warning-100);
}

.notification-player,
.hidden-language-changer {
    position: absolute;
    top: -10000px;
    left: -10000px;
}
.hidden-language-changer {
    visibility: hidden;
}
</style>
